import * as React from 'react';
import { accentUtils } from '../../services/HelperService';
import { ConfiguratorContext } from './ConfigContextProvider';
import { onSizeChanged, fromInt, toDecimal, useSizeChanged, configEvents, configEventControlType } from './ProductConfiguratorShared';
import { AccentLengthUnbound } from '../unbound/AccentLengthUnbound';




export const ConfigSizeSingle = props => {


    const ctx = React.useContext(ConfiguratorContext);
    const orderLine = ctx.config.OrderLine;

    const controlKey = `ConfigSizeSingle_${props.width}_${ctx.productID}`;
    const changeTag = `ConfigSizeSingle_${ctx.productID}`;

    const sizeChanged = useSizeChanged(accentUtils.getEmptyGuid(), controlKey, changeTag);

    const fireChange = React.useMemo(() => onSizeChanged(), [ctx.productID]);


    const baseUnit = ctx.config?.Data?.BaseUnit;
    const precision = ctx.config?.Data.ProductPrecision;

    const onChange = React.useCallback(e => {
        if (props.width) {
            orderLine.Width = e;
        } else {
            orderLine.Height = e;
        }

        fireChange(ctx, changeTag).then(() => {
            ctx.config?.Publish(configEvents.controlLostFocus, configEventControlType.singleSize);
        });

        

    }, [ctx, orderLine, props, fireChange, changeTag]);


    const onFocus = React.useCallback(e => {
        ctx.config?.Publish(configEvents.controlGotFocus, configEventControlType.singleSize);

    }, [ctx]);

    const notifyDirty = React.useCallback(e => {
        if (ctx.notifyDirty) {
            ctx.notifyDirty();
        }

    }, [ctx]);

    const value = props.width ? orderLine.Width : orderLine.Height;

    const key = sizeChanged.changeID;


    return <div className="config-size-single d-flex">
        <div>
            <AccentLengthUnbound
                key={key}
                defaultValue={value}
                defaultUnit={baseUnit}
                precision={ precision}
                onBlur={onChange}
                onChange={notifyDirty}
                onFocus={onFocus}
                required
                disabled={props.readOnly || ctx.isReadOnly}
                min={0}
                invalid={accentUtils.isEmpty(value)}
                debounceMilliseconds={50}
            />
        </div>
    </div>;
};